import { useState, useEffect } from "react";

export const useUsersListViewType = () => {
	const [viewTypeSelected, setViewTypeSelected] = useState(() => {
		// Inicjalizacja stanu z localStorage
		if (
			typeof window !== "undefined" &&
			typeof localStorage !== "undefined" &&
			localStorage !== null
		) {
			const saved = localStorage.getItem("usersListViewType");
			return saved === "grid" || saved === "list" ? saved : null;
		}
		return null;
	});

	// Nasłuchiwanie zmian w localStorage (w przypadku zmian z innych kart)
	useEffect(() => {
		const handleStorageChange = (e) => {
			if (e.key === "usersListViewType") {
				const newValue = e.newValue;
				setViewTypeSelected(
					newValue === "grid" || newValue === "list" ? newValue : null
				);
			}
		};

		window.addEventListener("storage", handleStorageChange);
		return () => window.removeEventListener("storage", handleStorageChange);
	}, []);

	const handleSetViewTypeSelected = (viewType) => {
		if (
			typeof window !== "undefined" &&
			typeof localStorage !== "undefined" &&
			localStorage !== null
		) {
			localStorage.setItem("usersListViewType", viewType);
			// Aktualizacja stanu React po zapisie do localStorage
			setViewTypeSelected(viewType);
		}
	};

	return {
		handleSetViewTypeSelected,
		viewTypeSelected,
	};
};
